import CheckboxField from "../FormItems/CheckboxField";
import InitialsField from "../FormItems/InitialsField";
import PictureField from "../FormItems/PictureField";
import RadioField from "../FormItems/RadioField";
import SignatureField from "../FormItems/SignatureField";
import SubTitleField from "../FormItems/SubTitleField";
import TextField from "../FormItems/TextField";
import TitleField from "../FormItems/TitleField";
import VideoField from "../FormItems/VideoField";

export const FormMap: Record<string, any> = {
  title: TitleField,
  subtitle: SubTitleField,
  text: TextField,
  checkbox: CheckboxField,
  signature: SignatureField,
  picture: PictureField,
  input: InitialsField,
  radio: RadioField,
  video: VideoField,
};
